import * as Types from '../action.types';
import * as Models from '../../models/index';
import * as Services from '../../service/index';
import * as toastr from 'toastr';

export const start = () => ({
	type: Types.PWD_RECOVERY_START,
});
export const setUserName = (username: string) => ({
	type: Types.PWD_RECOVERY_SET_USERNAME,
	payload: username,
});

export const goToQuestions = () => (d: Function, gs: () => Models.StoreState) => {
	d({
		type: Types.PWD_RECOVERY_PENDING,
	});

	Services.Recovery.loadQuestions({ username: gs().pwdRecovery.username }).then(questions => {
		var qs = questions
			.sort(() => {
				return Math.random() < 0.5 ? 1 : -1;
			})
			.slice(0, 2);
		d({
			type: Types.PWD_RECOVERY_SET_QUESTIONS,
			payload: qs,
		});
		if (questions.length > 0)
			d({
				type: Types.PWD_RECOVERY_GO_TO_QUESTIONS,
			});
	});
};

export const checkAnswers = () => (d: Function, gs: () => Models.StoreState) => {
	d({
		type: Types.PWD_RECOVERY_PENDING,
	});

	var ansObj = gs().pwdRecovery.answers;
	var answers = [];
	for (var field in ansObj) {
		answers.push(ansObj[field]);
	}

	Services.Recovery.sendAnswers({
		username: gs().pwdRecovery.username,
		answers: answers,
	}).then(allowReset => {
		if (!allowReset) {
			window.location.hash = '/password recovery';
		}
		d({
			type: Types.PWD_RECOVERY_CHECK_ANSWERS,
			payload: allowReset,
		});
	});
};

export const changeAnswer = (answer: string, questionId: string) => ({
	type: Types.PWD_RECOVERY_UPDATE_ANSWER,
	payload: { answer: answer, questionId: questionId } as Models.Answer,
});

export const resetPassword = () => (d: Function, gs: () => Models.StoreState) => {
	d({
		type: Types.PWD_RECOVERY_PENDING,
	});

	var ansObj = gs().pwdRecovery.answers;
	var answers = [];
	for (var field in ansObj) {
		answers.push(ansObj[field]);
	}

	Services.Recovery.resetPassword({
		username: gs().pwdRecovery.username,
		password: gs().pwdSecurity.password,
		confirm: gs().pwdSecurity.confirmPassword,
		answers: answers,
	}).then(result => {
		if (result.data) {
			toastr.success(result.message);
		} else {
			toastr.warning(result.message);
		}
		d({
			type: Types.PWD_RECOVERY_RESET,
			payload: result.data,
		});

		if (!!gs().pwdRecovery.reseted) window.location.href = '/login';
	});
};
